import React, { useEffect } from "react";
import { any } from "prop-types";

import { PopupButton } from "@typeform/embed-react";

import CoverPorfolio from "../../components/cover-portfolio";

import { LargeText, SmallHeading, SmallTitle } from "../../ui-components/texts";

// import PeopleOfMasamune from "../../components/people-of-masamune";
import { DetailsProject } from "../../components/portfolio-components";
import {
	Column,
	Container,
	ContainerBlock,
} from "../../ui-components/columns/components";
import { FullWidthVideo } from "../../ui-components/videos";
import PeopleOfMasamune from "../../components/people-of-masamune";

// images
import imageCover from "../../media/images/portfolio-images/ohoskin/cover.jpg";
import { ImageLeftWithText } from "./components-content";
import { useTranslate } from "../../contexts/translate";

const Ohoskin = ({
	setNextPageHref = () => {},
	setNextPageName = () => {},
}) => {
	const { translations } = useTranslate();

	useEffect(() => {
		setNextPageHref("/projects/micidial");
		setNextPageName("Micidial");
		document.title = 'Ohoskin - Cutting Edge Digital Creative Studio'
	}, []);

	const peoples = [
		{
			fullname: "Simone Ruiz",
			image: require("../../media/team-images/Simone Ruiz.jpg").default,
			role: translations === null ? "" : translations.about.peoples[1].role,
			description:
				translations === null ? "" : translations.about.peoples[1].description,
		},
		{
			fullname: "Michela Giuffrida",
			image: require("../../media/team-images/Michela Giuffrida.jpg").default,
			role: translations === null ? "" : translations.about.peoples[2].role,
			//description:
				//translations === null ? "" : translations.about.peoples[2].description,
			description:"",
		},
		{
			fullname: "Gabriele Nicolosi",
			image: require("../../media/team-images/Gabriele Nicolosi.jpeg").default,
			role: translations === null ? "" : translations.about.peoples[14].role,
			description:
				translations === null ? "" : translations.about.peoples[14].description,
		},
		{
			fullname: "Luca Distefano",
			image: require("../../media/team-images/no-image.png").default,
			role: "Former Video Maker",
			description: "",
		},
	];

	return (
		<div className="project-page project-page-ohoskin">
			<CoverPorfolio
				background="#fbffed"
				title="Ohoskin"
				text={translations && translations.ohoskin.intro}
				image={imageCover}
			/>

			<DetailsProject
				client={"Ohoskin"}
				services={["Social Video", "Photography"]}
				timeframe={"2020 - Today"}
				introduction={
					<>
						<LargeText>
							{translations && translations.ohoskin.descriptions[0]}
						</LargeText>
						<LargeText>
							{translations && translations.ohoskin.descriptions[1]}
						</LargeText>
						<LargeText>
							{translations && translations.ohoskin.descriptions[2]}
						</LargeText>
					</>
				}
			/>

			<ImageLeftWithText
				color="#A7B182"
				title={translations && translations.ohoskin.sections[0].title}
				texts={[
					translations && translations.ohoskin.sections[0].text
				]}
				image={
					require("../../media/images/portfolio-images/ohoskin/1.jpg").default
				}
				white={true}
			/>

			<section
				className="theme-light mid-padding"
				style={{ background: "#fff", paddingBottom: 1 }}
			>
				<ContainerBlock className="mid">
					<FullWidthVideo
						previewImage={
							require("../../media/images/portfolio-images/ohoskin/preview.jpg")
								.default
						}
						srcVideo={
							require("../../media/images/portfolio-images/ohoskin/ohoskin-1.mp4")
								.default
						}
					/>

					<SmallHeading className="mid-padding">
						{translations && translations.ohoskin.sections[1].text}
					</SmallHeading>

					<FullWidthVideo
						previewImage={
							require("../../media/images/portfolio-images/ohoskin/preview-2.jpg")
								.default
						}
						srcVideo={
							require("../../media/images/portfolio-images/ohoskin/ohoskin-2.mp4")
								.default
						}
					/>

					<SmallHeading className="mid-padding">
						{translations && translations.ohoskin.sections[2].text}
						sostenibilità.
					</SmallHeading>
				</ContainerBlock>
			</section>

			<section
				className="theme-light pt-0 mid-padding"
				style={{ background: "#fff" }}
			>
				<ContainerBlock className="mid" style={{ padding: "0" }}>
					<SmallTitle>
						{translations && translations.ohoskin.sections[3].title}
					</SmallTitle>
					<LargeText>
						{translations && translations.ohoskin.sections[3].text}
					</LargeText>
				</ContainerBlock>
			</section>

			<section
				className="theme-light mid-padding pt-4"
				style={{ background: "#fbffed" }}
			>
				<Container className="fluid" style={{ padding: "0 25px" }}>
					<div className="wrapper fluid p-1">
						<Column className="w-50">
							<img
								src={
									require("../../media/images/portfolio-images/ohoskin/image-1.jpg")
										.default
								}
								alt={"Image Test"}
							/>
							<img
								className="mt-5"
								src={
									require("../../media/images/portfolio-images/ohoskin/image-2.jpg")
										.default
								}
								alt={"Image Test"}
							/>
						</Column>
						<Column className="w-50">
							<img
								src={
									require("../../media/images/portfolio-images/ohoskin/image-3.jpg")
										.default
								}
								alt={"Image Test"}
							/>
							<img
								className="mt-5"
								src={
									require("../../media/images/portfolio-images/ohoskin/image-4.jpg")
										.default
								}
								alt={"Image Test"}
							/>
						</Column>
					</div>

					<div className="wrapper" style={{ paddingTop: 100 }}>
						<SmallHeading>
							{translations && translations.ohoskin.sections[4].text}
						</SmallHeading>
					</div>
				</Container>
			</section>

			<PeopleOfMasamune peoples={peoples} />
					<div className="cta-single-project">
				<div className="cta-single-project-inner">
					<p>{translations && translations.ctasingleproject.text}</p>
					<button
						className="leadconnector-button"
						onClick={() => {
							const overlay = document.createElement("div");
							overlay.style.cssText = `
													position: fixed;
													top: 0;
													left: 0;
													width: 100%;
													height: 100%;
													background-color: rgba(0, 0, 0, 0.7);
													backdrop-filter: blur(5px);
													z-index: 9998;
												`;

							const modal = document.createElement("div");
							modal.style.cssText = `
													position: fixed;
													top: 0;
													left: 0;
													width: 100%;
													height: 100%;
													z-index: 9999;
												`;

							const closeBtn = document.createElement("button");
							closeBtn.innerHTML = "✕";
							closeBtn.style.cssText = `
													position: fixed;
													top: 30px;
													right: 30px;
													width: 50px;
													height: 50px;
													border: none;
													background-color: rgba(255, 255, 255, 0.2);
													color: white;
													border-radius: 50%;
													cursor: pointer;
													font-size: 28px;
													z-index: 10000;
													transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
													backdrop-filter: blur(10px);
													border: 1px solid rgba(255, 255, 255, 0.3);
													display: flex;
													align-items: center;
													justify-content: center;
												`;
							closeBtn.onmouseover = () => {
								closeBtn.style.backgroundColor = "rgba(255, 255, 255, 0.3)";
								closeBtn.style.transform = "scale(1.15) rotate(90deg)";
								closeBtn.style.boxShadow = "0 8px 32px rgba(0, 0, 0, 0.3)";
								closeBtn.style.borderColor = "rgba(255, 255, 255, 0.5)";
							};
							closeBtn.onmouseout = () => {
								closeBtn.style.backgroundColor = "rgba(255, 255, 255, 0.2)";
								closeBtn.style.transform = "scale(1) rotate(0deg)";
								closeBtn.style.boxShadow = "none";
								closeBtn.style.borderColor = "rgba(255, 255, 255, 0.3)";
							};
							closeBtn.onclick = () => {
								overlay.style.opacity = "0";
								modal.style.opacity = "0";
								overlay.style.transition = "opacity 0.4s ease-out";
								modal.style.transition = "opacity 0.4s ease-out";
								setTimeout(() => {
									document.body.removeChild(overlay);
									document.body.removeChild(modal);
								}, 400);
							};

							const iframe = document.createElement("iframe");
							iframe.src =
								"https://api.leadconnectorhq.com/widget/survey/fXRdOm9p3aM4iNGpHfOa?notrack=true";
							iframe.style.cssText = `
													width: 100%;
													height: 100%;
													border: none;
												`;
							iframe.allowFullscreen = true;

							modal.appendChild(iframe);
							modal.appendChild(closeBtn);
							document.body.appendChild(overlay);
							document.body.appendChild(modal);

							overlay.onclick = () => {
								document.body.removeChild(overlay);
								document.body.removeChild(modal);
							};
						}}
					>
						{translations && translations.ctasingleproject.button}
					</button>
				</div>
			</div>
		</div>
	);
};

Ohoskin.propTypes = {
	setNextPageHref: any,
	setNextPageName: any,
};

export default Ohoskin;
